import { Grid } from '@mui/material'

import { Box, Flex, FloraTypography } from '@grupoboticario/flora-react'

import CheckboxItem from '@/components/EventSiteDisplay/CheckboxItem'

import { brandsBoxStyle, brandsTitleStyle, brandsAsteriskStyle } from './BrandsField.styles'

const BrandsField = ({ setFieldValue, values, isNewEvent, isReadOnly }) => {
  const handleBrandChange = (brand, checked) => {
    setFieldValue('brands', {
      ...values.brands,
      [brand]: checked
    })
  }

  const getCheckedValue = (brand) => {
    if (isNewEvent) {
      return values.brands?.[brand] ?? true
    }
    return values.brands?.[brand] ?? false
  }

  return (
    <Box css={brandsBoxStyle} data-testid="brands-field">
      <Grid container direction="column" spacing={2}>
        <Grid item md={6} sm={12} xs={12}>
          <FloraTypography css={brandsTitleStyle} fontSize="bodyLargeStandard">
            Brands
            <FloraTypography as="span" css={brandsAsteriskStyle} fontSize="bodyLargeStandard">
              *
            </FloraTypography>
          </FloraTypography>
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          <Flex gap="$4">
            <CheckboxItem
              checked={getCheckedValue('BOT')}
              disabled={isReadOnly}
              label="O Boticário"
              onChange={(checked) => handleBrandChange('BOT', checked)}
            />
            <CheckboxItem
              checked={getCheckedValue('QDB')}
              disabled={isReadOnly}
              label="Quem Disse, Berenice?"
              onChange={(checked) => handleBrandChange('QDB', checked)}
            />
            <CheckboxItem
              checked={getCheckedValue('BLZ')}
              disabled={isReadOnly}
              label="Beleza na Web"
              onChange={(checked) => handleBrandChange('BLZ', checked)}
            />
            <CheckboxItem
              checked={getCheckedValue('EUD')}
              disabled={isReadOnly}
              label="Eudora"
              onChange={(checked) => handleBrandChange('EUD', checked)}
            />
          </Flex>
        </Grid>
      </Grid>
    </Box>
  )
}

export default BrandsField
